// ====================================================
// Instantiates upsell popup for cart page or cart modal
(function SetupUpsellPopup() {

  // Get setup information
  const thisCode = document.getElementById('upsell-popup-code');
  let typeFunction;
  if (thisCode.dataset.template === 'cart') {
    typeFunction = loadTypeCartPage;
  } else {
    typeFunction = loadTypeCartModal;
  }

  // Setup
  let shownModal = false;
  document.addEventListener('DOMContentLoaded', typeFunction);

  // Setup upsell popup for cart page
  function loadTypeCartPage() {
    setupForms();
  }

  // Setup upsell popup for regular pages
  function loadTypeCartModal() {
    $('body').on('ajaxCart.afterCartLoad', function() {
      setupForms();
    });
  }

  function setupForms() {
    const forms = document.querySelectorAll('form[action="/cart"]');
    forms.forEach(form => form.addEventListener('submit', onFormSubmit));
  }

  function onFormSubmit(evt) {
    evt.preventDefault();

    if (popupUpsell) {
      // Display popup and set flags to avoid repeating displaying
      if (!getCookie('discount') && !shownModal) {
        shownModal = true;

        popupUpsell.open();
        return false;
      }
      // Reset display flag
      else {
        shownModal = false;
      }
    }

    // Get current cart items
    const cartItems = ajaxifyShopify.__currentCartContents.items;
    let clockys = 0, eyeMasks = 0, chargers = 0;

    for (let i = 0; i < cartItems.length; i++) {
        if (cartItems[i].handle === 'clocky') {
            clockys += cartItems[i].quantity;
        } else if (cartItems[i].handle === 'mask') {
            eyeMasks += cartItems[i].quantity;
        } else if (cartItems[i].handle === 'charger') {
            chargers += cartItems[i].quantity;
        }

        if (clockys >= 2 || eyeMasks >= 2 || chargers >= 2) {
          window.location.assign('/discount/TENOFFTWO?redirect=/checkout');
          return false;        
        }
    }

    // Proceed to checkout without applying discount
    window.location.assign('/checkout');
    return false;
  }

})();
